export default "__VITE_ASSET__4KnacQv9__"